import { Checkbox, FormGroup } from '@blueprintjs/core';
import { Routes } from '@just-in-types';
import * as React from 'react';
import { HandleRouteInput } from '.';

export interface RouteInputProps {
  label: string;
  onChange: HandleRouteInput;
  route?: Routes.Route;
  routeName: Routes.RouteString;
}

export const enum RouteAttribute {
  AlwaysShow = 'alwaysShow',
  Enabled = 'enabled',
  Optional = 'optional',
}

const RouteInput: React.SFC<RouteInputProps> = ({
  children,
  label,
  onChange,
  route,
  routeName,
}) => {
  const alwaysShow = route ? route.alwaysShow : false;
  const enabled = route ? route.enabled : false;
  const optional = route ? route.optional : false;

  const handleChange = ({
    currentTarget: { checked, name },
  }: React.FormEvent<HTMLInputElement>) =>
    onChange(routeName, name as RouteAttribute, checked);

  return (
    <FormGroup label={label}>
      <Checkbox
        checked={alwaysShow}
        label="always display"
        name={RouteAttribute.AlwaysShow}
        onChange={handleChange}
      />
      <Checkbox
        checked={enabled}
        label="enabled"
        name={RouteAttribute.Enabled}
        onChange={handleChange}
      />
      <Checkbox
        checked={optional}
        label="optional"
        name={RouteAttribute.Optional}
        onChange={handleChange}
      />
      {children}
    </FormGroup>
  );
};

export default RouteInput;



// WEBPACK FOOTER //
// ./src/components/SiteAdder/RouteInput.tsx